import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {AgentsAlerts} from "../../../agents/services/agents-alerts.service";
import {AgentDialogService} from "../../../agents/services/agent-dialogs-service.service";
import {AccountModel} from "../../angular/models/account.model";
import {$agentsFactory} from "../../../agents/$agents.factory";

export class SupplyAccountPanelCtrl implements IController {

  account: AccountModel;

  onDelete: Function;
  onClose: Function;

  private loading: boolean;
  private agentsRef: any;
  private agentIds: any;

  constructor(private $agents: $agentsFactory, private $log, private agentsAlerts: AgentsAlerts, private agentDialogService: AgentDialogService) {
  }

  $onInit() {
    this.agentsRef = this.$agents();

    this.agentIds = [];
    this.loading = false;

    if (this.account) {
      this.loading = true;
      this.agentsRef.$getAll({accountId: this.account.id, isActive:true})
        .then((agentIds) => {
          this.agentIds = agentIds
        })
        .catch((error) => {
          if (error) {
            this.agentsAlerts.getManyError();
            this.$log.error('Failed to get accounts agents', error);
          }
        })
        .finally(() => {
          this.loading = false;
        })
    }
  };

  $onChanges(changes) {
    if (changes.account && !changes.account.isFirstChange()) {
      const currentAccount = changes.account.currentValue;
      const previousAccount = changes.account.previousValue;

      if (currentAccount && currentAccount.id !== _.get(previousAccount, 'id')) {
        this.agentIds = [];
        this.$onInit();
      }
    }
  };

  onCreateDriver(event) {
    this.agentDialogService.createAgent(event, this.account)
      .then((createdAgent) => {
        this.agentIds = this.agentIds.concat([createdAgent.id]);
      })
  }
}

angular
  .module('bringoz.admin.accounts')
  .component('supplyAccountPanel', {
    bindings: {
      account: '<',
      onDelete: '&',
      onClose: '&'
    },
    template: require('./supply-account-panel.html').default,
    controller: SupplyAccountPanelCtrl
  });
